import { Button, Grid } from '@mui/material';
import LabelledDropdown from 'components/atoms/Dropdown/LabelledDropdown';
import { StainType } from 'interfaces/stainType';
import { map } from 'lodash';
import React from 'react';
import { useStainTypeIdToDisplayName } from 'utils/useStainTypeIdToDisplayName';

export const AddStain: React.FC<
  React.PropsWithChildren<{
    unassignedDeconvolutionStains: StainType[];
    setUpdatedSettings: (newStain: string) => void;
  }>
> = ({ unassignedDeconvolutionStains, setUpdatedSettings }) => {
  const { stainTypeIdToDisplayName } = useStainTypeIdToDisplayName();
  const [newStainMapping, setNewStainMapping] = React.useState<string>('');

  return (
    <Grid container direction="row" spacing={2} alignItems="center">
      {/* Select new stain to add to operation mapping */}
      <Grid item xs={5}>
        <LabelledDropdown
          size="small"
          label="Select Stain"
          options={map(unassignedDeconvolutionStains, (stainType) => ({
            text: stainTypeIdToDisplayName(stainType?.id),
            value: stainType?.id,
          }))}
          value={newStainMapping}
          onOptionSelected={(newValue) => setNewStainMapping(newValue)}
        />
      </Grid>
      {/* Add new stain as a new entry */}
      <Grid item xs={5}>
        <Button
          variant="outlined"
          onClick={() => {
            setUpdatedSettings(newStainMapping);
            setNewStainMapping('');
          }}
          disabled={!newStainMapping}
        >
          Add Stain
        </Button>
      </Grid>
    </Grid>
  );
};
